<div class="PGSaveStatus">
    @for (request of requests; track request) {
        @if (!request.hidden) {
            <div class="PGSaveStatus-Request pt-2 pg-animation-slideup border-top d-flex justify-content-between align-items-center">
                <!--<div class="pb-1 mb-2">
                <span>{{'pg-save-status.request-label-' + request.mode | locTranslate}}</span>&nbsp;<b>{{request.label | locTranslate}}</b>
                <div *ngIf="request.changed" class="small">{{'pg-save-status.request-changed' | locTranslate}}</div>
            </div>-->
            <div class="d-flex PGSaveStatus-Request-Variables align-items-center">
                @if (hasToggle(request, 'advanced')) {
                    <div class="PGSaveStatus-Request-Toggles pb-2 pe-3">
                        <div class="d-flex align-items-center">
                            <div class="me-2">{{ 'pg-save-status.toggle-advanced' | locTranslate }}</div>
                            <app-pg-switch [small]="true" [ariaLabel]="'pg-save-status.toggle-advanced' | locTranslate" [disabled]="isToggleDisabled(request, 'advanced')" [ngModel]="request.toggleValues.advanced" (ngModelChange)="request.setToggle('advanced', $event)"></app-pg-switch>
                        </div>
                    </div>
                }

                @if (hasToggle(request, 'advanced') && hasLanguages(request)) {
                    <div class="PGSaveStatus-Request-Split border-start pe-3"></div>
                }

                @if (hasLanguages(request)) {
                    <div class="PGSaveStatus-Request-Languages pb-2 pe-3">
                        <div class="d-flex align-items-center">
                            <div class="me-2">{{ 'pg-save-status.current-language' | locTranslate }}</div>
                            <div class="PGLanguageButtonBar">
                                @for (language of availableLanguages; track language) {
                                    @if (request.selectedLanguage == language || request.languages.indexOf(language) != -1) {
                                        <button type="button"
                                            class="btn btn-sm btn-{{request.selectedLanguage == language ? 'primary' : 'secondary'}}"
                                            [attr.aria-pressed]="request.selectedLanguage == language"
                                            [disabled]="request.languages.length < 2" (click)="request.setLanguage(language)">
                                            {{language.split('_')[0].toUpperCase()}}
                                        </button>
                                    }
                                }
                            </div>

                            @if(request.goToLanguagesManagement != null) {
                                <div class="ms-3">
                                    <button type="button" class="btn btn-link btn-sm p-0" (click)="request.goToLanguagesManagement()">
                                        <span>{{ 'pg-save-status.language-management' | locTranslate }}</span>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
            <div class="PGSaveStatus-Request-Actions d-flex justify-content-end pb-2">
                <div class="d-flex justify-content-end">
                    @if (hasAction(request, 'delete')) {
                        <app-pg-confirm-action [disabled]="isActionDisabled(request, 'delete')" (confirmed)="request.runAction('delete')">
                            <button type="button" class="btn btn-danger PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'delete')">
                                <div class="PGSaveStatus-Request-Actions-Button-Icon">
                                    <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                </div>
                                <span>{{'pg-save-status.action-delete' + (request.mode == 'create' ? '-draft': '') | locTranslate}}</span>
                            </button>
                        </app-pg-confirm-action>
                    }
                    @if (hasAction(request, 'cancel')) {
                        <button type="button" class="btn btn-secondary PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'cancel')" (click)="request.runAction('cancel')" >
                            <div class="PGSaveStatus-Request-Actions-Button-Icon">
                                <i class="fa-regular fa-undo" aria-hidden="true"></i>
                            </div>
                            <span>{{'pg-save-status.action-cancel' | locTranslate}}</span>
                        </button>
                    }
                </div>
                <div class="d-flex justify-content-end">
                    @if (hasAction(request, 'previous')) {
                        <button type="button" class="btn btn-secondary PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'previous')" (click)="request.runAction('previous')" >
                            <div class="PGSaveStatus-Request-Actions-Button-Icon">
                                <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                            </div>
                            <span>{{'pg-save-status.action-previous' | locTranslate}}</span>
                        </button>
                    }
                    @if (hasAction(request, 'next')) {
                        <button type="button" class="btn btn-primary PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'next')" (click)="request.runAction('next')" >
                            <span>{{'pg-save-status.action-next' | locTranslate}}</span>
                            <div class="PGSaveStatus-Request-Actions-Button-Icon PGSaveStatus-Request-Actions-Button-Icon--Reverse">
                                <i class="fa-regular fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </button>
                    }
                </div>
                <div class="d-flex justify-content-end">
                    @if (hasAction(request, 'duplicate')) {
                        <button type="button" class="btn btn-primary PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'duplicate')" (click)="request.runAction('duplicate')">
                            <div class="PGSaveStatus-Request-Actions-Button-Icon">
                                <i class="fa-regular fa-copy" aria-hidden="true"></i>
                            </div>
                            <span>{{'pg-save-status.action-duplicate' | locTranslate}}</span>
                        </button>
                    }
                    @if (hasAction(request, 'finish')) {
                        <button type="button" class="btn btn-primary PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'finish')" (click)="request.runAction('finish')" >
                            <span>{{'pg-save-status.action-finish' | locTranslate}}</span>
                            <div class="PGSaveStatus-Request-Actions-Button-Icon PGSaveStatus-Request-Actions-Button-Icon--Reverse">
                                <i class="fa-regular fa-arrow-right-to-line" aria-hidden="true"></i>
                            </div>
                        </button>
                    }
                    @if (hasAction(request, 'save')) {
                        <button type="button" class="btn btn-{{request.status == 'success' ? 'success' : request.status == 'error' ? 'danger' : 'primary'}} PGSaveStatus-Request-Actions-Button" [disabled]="isActionDisabled(request, 'save')" (click)="request.runAction('save')">
                            @if (request.status == 'running') {
                                <app-pg-loading [isOverlay]="true"></app-pg-loading>
                            }
                            <div class="PGSaveStatus-Request-Actions-Button-Icon">
                                <i class="fa-regular fa-save {{request.status == null || request.status == 'running' ? 'opacity-80' : 'opacity-00' }}" aria-hidden="true"></i>
                                <i class="fa-regular fa-check {{request.status == 'success' ? 'opacity-80' : 'opacity-00' }}" aria-hidden="true"></i>
                                <i class="fa-regular fa-times {{request.status == 'error' ? 'opacity-80' : 'opacity-00' }}" aria-hidden="true"></i>
                            </div>
                            <span>{{'pg-save-status.action-save' | locTranslate}}</span>
                        </button>
                    }
                </div>
            </div>
        </div>
    }
}
</div>

